export default "__VITE_ASSET____ayhV4$__"